import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const TopicSearch = styled.div`
  position: relative;
  ${({ noFilter }) => (!noFilter ? 'padding-right: 138px;' : null)};
  ${maxMediaQueries.phone`
    ${({ noFilter }) => (!noFilter ? 'padding-right: 120px;' : null)};
  `};

  svg {
    position: absolute;
    top: 4px;
    left: 0;
    color: ${({ theme }) => theme.mainColor};
  }
`;

export const TopicSearchInput = styled.input`
  display: block;
  width: 100%;
  padding: 0 0 6px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  margin-bottom: 24px;
  font-size: 20px;
  line-height: 20px;

  ::placeholder {
    color: ${({ theme }) => theme.placeholderColor};
  }

  &:focus {
    border-color: ${({ theme }) => theme.mainColor};
  }
`;
